import { render, staticRenderFns } from "./IconPolicy.vue?vue&type=template&id=c3bac878&"
import script from "./IconPolicy.vue?vue&type=script&lang=js&"
export * from "./IconPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports